
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blur-effect",
      function () {
        return require("private-next-pages/blur-effect/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blur-effect"])
      });
    }
  